module.exports = __webpack_public_path__ + "static/img/gggggg_26.fb8b5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_26.png
// module id = SRG4
// module chunks = 1